module.exports = __webpack_public_path__ + "static/media/game-pad.31d25353.png";